/* eslint-disable */
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { compose } from 'redux';
import UserMenu from '../../Components/UserMenu/UserMenu.component';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import AccountsPageSidebarPropTypes from './Accounts.page.sidebar.props';
import accountsPageStyles from './Accounts.page.styles';

/**
 * AccountsPageSidebarComponent
 * @export
 * @class AccountsPageSidebarComponent
 * @extends {React.Component<AccountsPageSidebarComponentComposedProps, AccountsPageSidebarComponentState>}
 */
export class AccountsPageSidebarComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<AccountsPageSidebarComponentProps>}
   * @memberof AccountsPageSidebarComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`AccountsPageSidebar`}
   * @memberof AccountsPageSidebarComponent
   */
  static displayName = `AccountsPageSidebar`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof AccountsPageSidebarComponent
   */
  static propTypes = AccountsPageSidebarPropTypes;

  /**
   * Data specific to the `<AccountsPageSidebar />` instance
   * @type {AccountsPageSidebarComponentState}
   * @memberof AccountsPageSidebarComponent
   */
  state = {};

  /**
   * Render the sidebar
   * @returns {React.Component} The rendered `<AccountsPageSidebar />`
   * @memberof AccountsPageSidebarComponent
   */
  render() {
    return <UserMenu showAvatar={false} />;
  }
}

/** @type {React.ComponentClass<AccountsPageSidebarComponentProps>} */
const AccountsPageSidebar = compose(withStyles(themeCreateInjectableStyles(accountsPageStyles), { withTheme: true }))(AccountsPageSidebarComponent);

export default AccountsPageSidebar;
